$(document).ready(function() {
    // remove product example
    $('.plant-position-picker_remove').on("click", function() {
        $(this).siblings('span').text("");
        $(this).siblings('img').attr("src", "");
        event.stopPropagation();

        //remove from visual box
        let plantpos = $(this).parent('.plant-position-picker').attr("data-plantpicker");
        console.log("Plantpos: " + plantpos);
        $(".plant-visual-wrapper__box-drop--" +plantpos+ " img" ).attr("src", "");

        //remove from modal
        let plantmodalremove = $(this).parent('.plant-position-picker').attr("data-modalremove");
        console.log("This: " + plantmodalremove);
        //$("input:radio[name='" + plantmodalremove  + "']").prop('checked', 'false');
        //$("input[name='" + plantmodalremove + "']").prop('checked', 'false');
        $("input:radio[name='" + plantmodalremove  + "']").each(function () {
            
            $(this).removeAttr('checked');
		    $(this).prop('checked', false);
        })
        
        
    });
    // open modal
    $('.plant-position-picker').on('click', function() {
        $('.plant-position-modals_selector').removeClass('active');
        var modalID = $(this).attr('data-plantpicker');
        $('.plant-position-modals_selector[data-plantmodals = '+modalID+']').addClass('active');
        $('html').addClass("no-scroll");

        // Search bar
        $(".plant-position-modals__plantlist > label").show();
        $('.modal-search').val('');
        $('.plant-position-modals_selector[data-plantmodals = '+modalID+'] .modal-search').on("keyup", function() {
            var value = $(this).val().toLowerCase();
            console.log(value);
            $(".plant-position-modals__plantlist > label").show().filter(function() {                           //Select all labels/inputs and show
            return $(this).find('input').attr('data-title').toLowerCase().indexOf(value) === -1;  //Find the data-attribute and check if the value is substring of the attr. Return true if not found.
            }).hide();                                                          //Hide all labels that the value is not the substring of attr
        });

        // Tag list
        /* 
        $('.plant-position-modals__header--tags p').val('');
        $('.plant-position-modals_selector[data-plantmodals=' + modalID + '] .plant-position-modals__header--tags p').on("click", function() {
            $(this).addClass('active').siblings().removeClass('active');

            if ($(this).attr('data-tag')) {
                var value2 = $(this).attr('data-tag');
                console.log(value2);
                
                // Ensure 'testing' and 'testing2' are not undefined
            var testing = $('.plant-position-modals_selector[data-plantmodals=' + modalID + '] .plant-position-modals__plantlist > label').find('input').attr('data-tags');
            console.log(testing);

            $('.plant-position-modals_selector[data-plantmodals=' + modalID + '] .plant-position-modals__plantlist > label').show().filter(function() {
                var testing2 = $(this).find('input').attr('data-tags');
                if (testing2 !== undefined) {
                    console.log("yes? ", testing2.includes(value2));
                    var exists = testing2.includes(value2);
                    console.log("match: ", exists);
                    return !exists; // Hide the labels where data-tags does not include value2
                } else {
                    return true; // Hide the label if 'data-tags' attribute is missing
                }
            }).hide();
            }
        });
         */
        // Tag list functionality
        $(document).on("click", '.plant-position-modals_selector.active .plant-position-modals__header--tags p', function() {
            var $activeModal = $(this).closest('.plant-position-modals_selector');
            $(this).addClass('active').siblings().removeClass('active');
            $activeModal.find(".plant-position-modals__header--tags p.show-all").addClass("show");
            if ($(this).attr('data-tag')) {
                var value2 = $(this).attr('data-tag');
                console.log(value2);

                $activeModal.find(".plant-position-modals__plantlist > label").show().filter(function() {
                    var testing2 = $(this).find('input').attr('data-tags');
                    if (testing2 !== undefined) {
                        console.log("yes? ", testing2.includes(value2));
                        var exists = testing2.includes(value2);
                        console.log("match: ", exists);
                        return !exists; // Hide the labels where data-tags does not include value2
                    } else {
                        return true; // Hide the label if 'data-tags' attribute is missing
                    }
                }).hide();
            }
        });
        $(document).on("click", '.plant-position-modals_selector.active .plant-position-modals__header--tags p.show-all', function() {
            var $activeModal = $(this).closest('.plant-position-modals_selector');
            $(this).removeClass('show').siblings().removeClass('active');
            $activeModal.find(".plant-position-modals__plantlist > label").show();
        });

    });


    // close modal
    $('.plant-position-picker_close, .plant-position-picker_cancel').on('click', function() {
        $('.plant-position-modals_selector').removeClass('active');
        $('html').removeClass("no-scroll");
        /* if ($("input:radio[name='plant-position-1']").is(':checked')) {
            let plantExample1 = $("input:radio[name='plant-position-1']:checked").attr("data-title");
            $( ".plant-position-picker[data-plantpicker='plant_1'] span" ).text(plantExample1);
            
            // place plant in visual box
            let plantImage1 = $("input:radio[name='plant-position-1']:checked").attr("data-image");
            $(".plant-visual-wrapper__box-drop--plant_1 img" ).attr("src", plantImage1);
        }
        if ($("input:radio[name='plant-position-2']").is(':checked')) {
            let plantExample2 = $("input:radio[name='plant-position-2']:checked").attr("data-title");
            $( ".plant-position-picker[data-plantpicker='plant_2'] span" ).text(plantExample2);

            // place plant in visual box
            let plantImage2 = $("input:radio[name='plant-position-2']:checked").attr("data-image");
            $(".plant-visual-wrapper__box-drop--plant_2 img" ).attr("src", plantImage2);
        }
        if ($("input:radio[name='plant-position-3']").is(':checked')) {
            let plantExample3 = $("input:radio[name='plant-position-3']:checked").attr("data-title");
            $( ".plant-position-picker[data-plantpicker='plant_3'] span" ).text(plantExample3);

            // place plant in visual box
            let plantImage3 = $("input:radio[name='plant-position-3']:checked").attr("data-image");
            $(".plant-visual-wrapper__box-drop--plant_3 img" ).attr("src", plantImage3);
        }
        if ($("input:radio[name='plant-position-4']").is(':checked')) {
            let plantExample4 = $("input:radio[name='plant-position-4']:checked").attr("data-title");
            $( ".plant-position-picker[data-plantpicker='plant_4'] span" ).text(plantExample4);

            // place plant in visual box
            let plantImage4 = $("input:radio[name='plant-position-4']:checked").attr("data-image");
            $(".plant-visual-wrapper__box-drop--plant_4 img" ).attr("src", plantImage4);
        } */
    });
    // choose plant in modal and add selected product to example
    $('.plant-position-picker_choose').on('click', function() {
        $('.plant-position-modals_selector').removeClass('active');
        $('html').removeClass("no-scroll");
        if ($("input:radio[name='plant-position-1']").is(':checked')) {
            // place plant in example box
            let plant1 = $("input:radio[name='plant-position-1']:checked");

            $( ".plant-position-picker[data-plantpicker='plant_1'] img" ).attr("src", plant1.attr("data-image"));
            $( ".plant-position-picker[data-plantpicker='plant_1'] span" ).text(plant1.attr("data-title"));
            // place plant in visual box
            $(".plant-visual-wrapper__box-drop--plant_1 img" ).attr("src", plant1.attr("data-image"));
        }
        if ($("input:radio[name='plant-position-2']").is(':checked')) {
            // place plant in example box
            let plant2 = $("input:radio[name='plant-position-2']:checked");

            $( ".plant-position-picker[data-plantpicker='plant_2'] img" ).attr("src", plant2.attr("data-image"));
            $( ".plant-position-picker[data-plantpicker='plant_2'] span" ).text(plant2.attr("data-title"));
            // place plant in visual box
            $(".plant-visual-wrapper__box-drop--plant_2 img" ).attr("src", plant2.attr("data-image"));
        }
        if ($("input:radio[name='plant-position-3']").is(':checked')) {
            // place plant in example box
            let plant3 = $("input:radio[name='plant-position-3']:checked");

            $( ".plant-position-picker[data-plantpicker='plant_3'] img" ).attr("src", plant3.attr("data-image"));
            $( ".plant-position-picker[data-plantpicker='plant_3'] span" ).text(plant3.attr("data-title"));
            // place plant in visual box
            $(".plant-visual-wrapper__box-drop--plant_3 img" ).attr("src", plant3.attr("data-image"));
        }
        if ($("input:radio[name='plant-position-4']").is(':checked')) {
             // place plant in example box
             let plant4 = $("input:radio[name='plant-position-4']:checked");

             $( ".plant-position-picker[data-plantpicker='plant_4'] img" ).attr("src", plant4.attr("data-image"));
             $( ".plant-position-picker[data-plantpicker='plant_4'] span" ).text(plant4.attr("data-title"));
             // place plant in visual box
             $(".plant-visual-wrapper__box-drop--plant_4 img" ).attr("src", plant4.attr("data-image"));
        }
    });

    

    // choose/change product in modals and add to buy button
    $("input:radio[name='plant-position-1']").on("change", function() {
        let plant_position_1 = $("input:radio[name='plant-position-1']:checked").val();
        $("#plant_position_1_id").val(plant_position_1);
        console.log("Plantepos 1: " + plant_position_1 );
    });
    $("input:radio[name='plant-position-2']").on("change", function() {
        let plant_position_2 = $("input:radio[name='plant-position-2']:checked").val();
        $("#plant_position_2_id").val(plant_position_2);
        console.log("Plantepos 2: " + plant_position_2 );
    });
    $("input:radio[name='plant-position-3']").on("change", function() {
        let plant_position_3 = $("input:radio[name='plant-position-3']:checked").val();
        $("#plant_position_3_id").val(plant_position_3);
        console.log("Plantepos 3: " + plant_position_3 );
    });
    $("input:radio[name='plant-position-4']").on("change", function() {
        let plant_position_4 = $("input:radio[name='plant-position-4']:checked").val();
        $("#plant_position_4_id").val(plant_position_4);
        console.log("Plantepos 4: " + plant_position_4 );
    });

    // color change 
    $('.plant-color-wrapper .plant-color-wrapper__button').on('click', function() {
        $('.plant-color-wrapper .plant-color-wrapper__button').removeClass('active');
        $(this).addClass("active");
        var boxImageFront = $(this).attr("data-box-front");
        var boxImageBack = $(this).attr("data-box-back");
        $('.plant-visual-wrapper__box-front').attr("src", boxImageFront);
        $('.plant-visual-wrapper__box-back').attr("src", boxImageBack);

        var variantId = $(this).attr("data-variant-id");
        $("#main_product").val(variantId);      
    });

    // extra product check 
    var extraProductExists = document.getElementById("extra_product");

    
        

    // extra change 
    if (extraProductExists) {
        $('.plant-extra-wrapper .plant-extra-wrapper__button').on('click', function() {
            $('.plant-extra-wrapper .plant-extra-wrapper__button').removeClass('active');
            $(this).addClass("active");

            var variantId = $(this).attr("data-variant-id");
            $("#extra_product").val(variantId);      
        });
    }


    // add to cart + group items 
    $(".ProductForm__AddToCart.altankasse-submit").on("click", function(e) {
        e.preventDefault();

        var color = $('.plant-color-wrapper__button.active').attr("data-box-color");
        var size = $(this).attr("data-altankasse-size");


        var items = [];

        var mainID = $(this).attr("data-altankasse-id");
        var mainProduct = {
            quantity: 1,
            id: $("#main_product").val(),
            properties: {
                '_mainid:': mainID,
                '_pos:': mainID,
                '_refid': mainID,
                }
        }
        items.push(mainProduct);

        

        var altankassePlants = $('.altankasse-plante');

        var uniqueID = "Altankasse - Størrelse: ";
             uniqueID += size;
             uniqueID += ", Farve: ";
             uniqueID += color;
             uniqueID += ", ID: ";
            uniqueID += $(this).attr("data-altankasse-id");

        var lineID = $(this).attr("data-altankasse-id");

        /* extra product */
        if (extraProductExists) {

            var extraProduct = {
                quantity: 1,
                id: $("#extra_product").val(),
                properties: {
                    '_altan:': uniqueID,
                    '_refid': lineID,
                    }
            }
            items.push(extraProduct);
        }

        

        /* plants */
        altankassePlants.each(function(i) {
            var id = parseInt($(this).val());
            var pos = $(this).attr("data-pos");
            

            var obj = {
                quantity: 1,
                id: id,

                properties: {
                '_altan:': uniqueID,
                '_pos:': pos,
                '_refid': lineID,
                }
            }

            items.push(obj);
        })

        // Reverse items array to outout in same order they are picked
        items = items.reverse();
        
            if (items.length > 0) {
                $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: {items: items},
                dataType: 'json',
                success: function() {
                    console.log("Good job");
                    window.location.href = "/cart";  
                },
                error: function() {
                    // Do something on error (e.g. show an error message)
                }
                })
            } else {
                console.log("Denied ");
            }
    });


    /* Mobile functions */
// Create a media condition that targets viewports at least 768px wide
const mediaQuery = window.matchMedia('(max-width: 1000px)')
// Check if the media query is true
if (mediaQuery.matches) {

 

    

    let active = 0;
    let el = $(".slide-wrapper");
    let total = el.length - 1;

    const toggle = (el, index) => {
    el.hide()
    el.removeClass('active')
    el.eq(index).addClass('active')
    el.eq(index).show()
    }

    toggle(el, active)
    var currentStepId = 1;
    var noExtra = $('.slide-outer-wrapper').find('.slide-wrapper.active').attr('data-summary');
    

    $('.step-button').on('click', function() {
        
        // prev next step
        this.id === 'prev' ? active -= 1 : active += 1;
        if(active > total) active = 0;
        if(active < 0) active = total
        toggle(el, active)

        currentStepId = $('.slide-outer-wrapper').find('.slide-wrapper.active').attr('data-slide');
        console.log('Current: ', currentStepId);
        // sets correct step in progress bar
        $('.mobile-progress-bar__bar-step').removeClass('active');
        $('.mobile-progress-bar__bar .step-'+currentStepId).addClass('active');
        var previousStepId = currentStepId-1;

        if (this.id === 'next') {
            $('.mobile-progress-bar__bar .step-'+previousStepId).addClass('done');
        }
        else {
            $('.mobile-progress-bar__bar .step-'+currentStepId).removeClass('done');
        }

        if (currentStepId == 1) {
            $('.step-button.prev-step').css('display', 'none');
        }
        else {
            $('.step-button.prev-step').css('display', 'flex');
        }

        if (currentStepId == 5 || currentStepId == 4 && noExtra ) {
            $('.altankasse-submit').show();
            $('.step-button.next-step').hide();

            // add size to mobile summary
            var chosenSize = $('.plant-visual-wrapper_box-wrapper').attr("data-mainproduct-title");
             $('#summary-table-size span').html(chosenSize);
             // add color to mobile summary
             var chosenColor = $('.plant-color-wrapper__button.active').attr("data-box-color");
             $('#summary-table-color span').html(chosenColor);


             var chosenExtra = $('.plant-extra-wrapper__button.active').attr("data-box-color");
             $('#summary-table-extra span').html(chosenExtra);

             // add plants to mobile summary
             var chosenPlants = [];

            if ($("input:radio[name='plant-position-1']").is(':checked')) {
                let chosenPlant = $("input:radio[name='plant-position-1']:checked");
                var chosenPlantTitle = chosenPlant.attr("data-title");

                chosenPlants.push(chosenPlantTitle);
            }
            if ($("input:radio[name='plant-position-2']").is(':checked')) {
                let chosenPlant = $("input:radio[name='plant-position-2']:checked");
                var chosenPlantTitle = chosenPlant.attr("data-title");

                chosenPlants.push(chosenPlantTitle);
            }
            if ($("input:radio[name='plant-position-3']").is(':checked')) {
                let chosenPlant = $("input:radio[name='plant-position-3']:checked");
                var chosenPlantTitle = chosenPlant.attr("data-title");

                chosenPlants.push(chosenPlantTitle);
            }
            if ($("input:radio[name='plant-position-4']").is(':checked')) {
                let chosenPlant = $("input:radio[name='plant-position-4']:checked");
                var chosenPlantTitle = chosenPlant.attr("data-title");

                chosenPlants.push(chosenPlantTitle);
            }
            console.log(chosenPlants);
            $('#summary-table-plant span').html(chosenPlants.join(", "));

        }
        else {
            $('.altankasse-submit').hide();
            $('.step-button.next-step').show();
        }
    })

}
});